namespace RedBullMOBILE360.Settings {

    @Serenity.Decorators.registerClass('RedBullMOBILE360.Settings.ServiceParametersDialog')
    export class ServiceParametersDialog extends Serenity.EntityDialog<ServiceParametersRow, any> {
        protected getFormKey() { return ServiceParametersForm.formKey; }
        protected getIdProperty() { return ServiceParametersRow.idProperty; }
        protected getLocalTextPrefix() { return ServiceParametersRow.localTextPrefix; }
        protected getNameProperty() { return ServiceParametersRow.nameProperty; }
        protected getService() { return ServiceParametersService.baseUrl; }
        protected getDeletePermission() { return ServiceParametersRow.deletePermission; }
        protected getInsertPermission() { return ServiceParametersRow.insertPermission; }
        protected getUpdatePermission() { return ServiceParametersRow.updatePermission; }

        protected form = new ServiceParametersForm(this.idPrefix);
    }
}